module.exports = __webpack_public_path__ + "why1.png?994a56b58b6c389cabc9eab475e8c9a8";